
import type { MetadataEntity } from '../metadata-entity';

import { $$classMetadataPropertyMetadataControlInjector } from './class-metadata-property-metadata-control-injector';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Required() {
	return function(model: MetadataEntity, property: string): void {
		$$classMetadataPropertyMetadataControlInjector(
			model,
			property,
			{ required: true },
		);
	};
}
